import { render } from "./IdaVuelta.vue?vue&type=template&id=93a41b8a"
import script from "./IdaVuelta.vue?vue&type=script&lang=js"
export * from "./IdaVuelta.vue?vue&type=script&lang=js"

import "./IdaVuelta.vue?vue&type=style&index=0&id=93a41b8a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__